import { RouterProvider } from 'react-router-dom';
import { createPortal } from 'react-dom';

import { ToastContainer } from 'react-toastify';

// navigation
import { router } from './router/root';
import { LoadingInitial } from './components/pages/loading-initial';
import { ThemeProvider } from './components/providers/theme-provider';

export const App = () => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vitazi-portal-theme">
      <RouterProvider router={router} fallbackElement={<LoadingInitial />} />
      {createPortal(<ToastContainer stacked />, document.body)}
    </ThemeProvider>
  );
};
